module.exports = __webpack_public_path__ + "static/04-fd5fdc7c57f6edf2c5ee2aa995665fa4.jpg";